import axios from 'axios';
import { createSignedGetRequest } from 'utils/createSignedRequestsHelpers';

export const getJydacomReportStatus = async (projectId, reportId) => {
  const apiPath = `report/project/${projectId}/jydacom-report/${reportId}`;

  const signedRequest = await createSignedGetRequest({
    apiPath,
  });

  const response = await axios(signedRequest);

  return response.data;
};
